import React, { Component } from 'react';

import uuidv1 from 'uuid/v1';

import ReactTooltip from 'react-tooltip';

import sensorRed from '../../../assets/img/ic_sensor_red.png';
import sensorAmber from '../../../assets/img/ic_sensor_amber.png';

class TrailerBogie extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allLoaded: false,
      allWheelWithEvents: []
    };
  }

  onClickBogie = bogie => {
    this.props.clickBogie(bogie.Reference);
  };

  onClick = (e, position, side) => {
    const functionalLocation = e.target.getAttribute('data-funclocation');
    const reference = e.target.getAttribute('data-reference');
    var assetKey = e.target.getAttribute('data-assetkey');
    if (assetKey.includes('<br />'))
      assetKey = assetKey.split('<br />')[0].trim();
    this.props.clickElement(
      e,
      position,
      this.props.bogie,
      side,
      functionalLocation,
      reference,
      assetKey
    );
    // TODO, Confirmar que cambia los valores del padre en clickElement={this.clicked}, no llama a la función padre con ese nombre
  };

  getAxleboxReference(wheelsetReference, side) {
    var retAxlebox;

    this.props.wheelsets.map(wheel => {
      if (wheel.Reference === wheelsetReference) {
        wheel.Axleboxes.map(axlebox => {
          if (axlebox.Side === side) {
            retAxlebox = axlebox;
          }
        });
      }
    });

    return retAxlebox;
  }

  getGearBox(wheelsetReference, type) {
    var key = {};
    this.props.wheelsets.map(e => {
      if (e.Reference === wheelsetReference) {
        if (type === 'GB') key = e.GearBox;
        if (type === 'TM') key = e.TractionMotor;
      }
    });

    return key;
  }

  getAlarm(wheelsetReference, side, type) {
    var ret = '';
    var retAxlebox = this.getAxleboxReference(wheelsetReference, side);

    if (
      !retAxlebox ||
      (retAxlebox.IMEI === '' && !this.props.IMxRail) ||
      (retAxlebox.IMEI === null && !this.props.IMxRail)
    ) {
      ret = 'filNoCommissioned';
    } else {
      this.props.allWheelWithEvents.map(wheel => {
        wheel.forEach(axlebox => {
          if (axlebox.functionalLocationReference == retAxlebox.Reference) {
            if (axlebox.functionalLocationEvents) {
              if (axlebox.functionalLocationEvents.length === 0) {
                ret = '';
                if (this.props.IMxRail) ret = 'Ok';
              } else {
                var isAmber = false;
                var isRed = false;
                if (this.props.IMxRail) ret = 'Ok';
                //ret = "filAlarm";

                axlebox.functionalLocationEvents.map(event => {
                  if (
                    event.activeAlarm.toLowerCase() === 'red' &&
                    event.assetType &&
                    (event.assetType.toLowerCase() === type ||
                      (event.assetType === 'Axlebox' && type == 'axlebox'))
                  ) {
                    isRed = true;
                    isAmber = false;
                    //  ret = "filRed";
                  }
                  if (
                    event.activeAlarm.toLowerCase() === 'amber' &&
                    !isRed &&
                    event.assetType &&
                    event.assetType.toLowerCase() === type
                  ) {
                    isAmber = true;
                    //ret = "filRed";
                  }
                });
                if (isRed) {
                  ret = 'filRed';
                }
                if (isAmber) {
                  ret = 'filAlarm';
                }
              }
            } else {
              ret = '';
            }
          }
        });
      });
    }

    return ret;
  }

  getSensor(wheelsetReference, side, type) {
    var ret = 'hideAsset';
    var isAmber = false;
    var isRed = false;
    var retAxlebox = this.getAxleboxReference(wheelsetReference, side);

    this.props.allWheelWithEvents.map(wheel => {
      wheel.forEach(axlebox => {
        if (
          retAxlebox &&
          axlebox.functionalLocationReference == retAxlebox.Reference
        ) {
          if (axlebox.functionalLocationEvents) {
            if (axlebox.functionalLocationEvents.length === 0) {
              ret = 'hideAsset';
            } else {
              //ret = "filAlarm";
              axlebox.functionalLocationEvents.map(event => {
                if (
                  event.activeAlarm.toLowerCase() === 'red' &&
                  event.assetType &&
                  event.assetType.toLowerCase() === type
                ) {
                  isRed = true;
                  //  ret = "filRed";
                }
                if (
                  event.activeAlarm.toLowerCase() === 'amber' &&
                  event.assetType &&
                  event.assetType.toLowerCase() === type
                ) {
                  isAmber = true;
                  //ret = "filRed";
                }
              });
              if (isRed) {
                ret = '';
              }
              if (isAmber) {
                ret = '';
              }
            }
          } else {
            ret = 'hideAsset';
          }
        } else {
          ret = 'hideAsset';
        }
      });
    });

    if (isRed || isAmber) {
      ret = '';
    }

    return ret;
  }

  getFunctionalLocation(wheelsetReference, side) {
    var retAxlebox = this.getAxleboxReference(wheelsetReference, side);
    return retAxlebox ? retAxlebox.LocationName : '';
  }

  getIMEI(wheelsetReference, side) {
    var retAxlebox = this.getAxleboxReference(wheelsetReference, side);
    let imei = retAxlebox ? retAxlebox.IMEI : '';
    if (imei && imei !== '') return 'IMEI: ' + imei;
    else return '';
  }

  getReference(wheelsetReference, side) {
    var retAxlebox = this.getAxleboxReference(wheelsetReference, side);
    return retAxlebox ? retAxlebox.Reference : '';
  }

  getAssetKey(wheelsetReference, side) {
    var retAxlebox = this.getAxleboxReference(wheelsetReference, side);
    return retAxlebox ? retAxlebox.AssetKey : '';
  }

  getAssetKeyGB(wheelsetReference, getAssetKeyGB) {
    var gearbox = this.getGearBox(wheelsetReference, getAssetKeyGB);
    return gearbox ? gearbox.AssetKey : '';
  }

  getFunctionalLocationeGB(wheelsetReference, getAssetKeyGB) {
    var gearbox = this.getGearBox(wheelsetReference, getAssetKeyGB);
    return gearbox ? gearbox.LocationName : '';
  }

  getReferenceGB(wheelsetReference, getAssetKeyGB) {
    var gearbox = this.getGearBox(wheelsetReference, getAssetKeyGB);
    return gearbox ? gearbox.Reference : '';
  }

  isActive(wheelsetReference, side) {
    var ret = '';
    var retAxlebox = this.getAxleboxReference(wheelsetReference, side);
    if (this.props.lastLevel) {
      var positionClicked = parseInt(this.props.positionClicked);
      if (positionClicked !== 0) {
        if (positionClicked === this.getCarriagePostion(wheelsetReference)) {
          if (retAxlebox.Reference !== this.props.axleBoxReference) {
            ret = 'filOpacity';
          }
        }
      }
    }

    if (this.props.bogieSelected && this.props.bogieSelected.Wheelsets) {
      if (!this.props.bogieSelected.Wheelsets.includes(wheelsetReference))
        ret = 'filOpacity';
    }

    return ret;
  }

  getCarriagePostion(wheelset) {
    var position = 1;
    if (this.props.carriages) {
      this.props.carriages.map(carriage => {
        carriage.Wheelsets.map(wheel => {
          if (wheel === wheelset) {
            position = carriage.Position;
          }
        });
      });
    }

    return position;
  }

  isOpacity(pos) {
    var ret = '';
    var positionClicked = parseInt(this.props.positionClicked);
    if (positionClicked !== 0) {
      if (
        positionClicked !==
        this.getCarriagePostion(this.props.unitWheelSets[pos])
      ) {
        ret = 'filOpacity';
      }
    }

    return ret;
  }

  isOpacitymGB(wheelsets, unitWheelSet, type) {
    var ret = '';
    //We are clicking a Gearbox or Traction motor (axlebox)
    if (this.props.axleBoxReference) {
      const wheel = wheelsets.find(e => e.Reference === unitWheelSet);
      if (wheel[type]?.Reference !== this.props.axleBoxReference)
        ret = 'filOpacity';
    }
    //We are clicking a Bogie
    else if (this.props.bogieSelected) {
      var isUnitWheelSetInTheSelectedBogie = this.props.bogieSelected.Wheelsets.includes(
        unitWheelSet
      );
      ret = isUnitWheelSetInTheSelectedBogie ? '' : 'filOpacity';
    }
    return ret;
  }

  getAlarmGB(wheelsets, unitWheelSet, type) {
    if (!this.props.IMxRail) return '';
    let alarm = 'Ok';
    const wheel = wheelsets.find(e => e.Reference === unitWheelSet);
    const alarms = this.props.events.map(e => {
      if (e.functionalLocationReference === wheel[type].Reference) {
        return e.activeAlarm;
      }
    });
    alarms.map(e => {
      if (alarm === 'Ok' && e === 'Amber') alarm = e;
      if ((alarm === 'Amber' || alarm === 'Ok') && e === 'Red') alarm = e;
    });
    return alarm;
  }

  render() {
    const wheelsets = this.props.wheelsets;
    const unitWheelSets = this.props.unitWheelSets;
    const isMotor = this.props.isMotor;
    const lastLevel = this.props.lastLevel;

    if (isMotor) {
      return (
        <div key={uuidv1()}>
          {/************* Sensors positions ***********/}
          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[1],
              'LH'
            )}
            <br />  ${this.getIMEI(unitWheelSets[1], 'LH')}
            `}
            data-for="svgTooltipBottom"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[1],
              'LH'
            )}
            
            `}
            data-reference={`${this.getReference(unitWheelSets[1], 'LH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[1], 'LH')}`}
            onClick={e =>
              this.onClick(
                e,
                1,
                'LH',
                this.getFunctionalLocation(unitWheelSets[1], 'LH')
              )
            }
            className={`sensorTopLeft cursor  ${this.getSensor(
              unitWheelSets[1],
              'LH',
              'sensor'
            )} `}
          />

          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[0],
              'LH'
            )}
            <br />  ${this.getIMEI(unitWheelSets[0], 'LH')}
            `}
            data-for="svgTooltipBottom"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[0],
              'LH'
            )}`}
            data-reference={`${this.getReference(unitWheelSets[0], 'LH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[0], 'LH')}`}
            onClick={e =>
              this.onClick(
                e,
                0,
                'LH',
                this.getFunctionalLocation(unitWheelSets[0], 'LH')
              )
            }
            className={`sensorTopRight cursor  ${this.getSensor(
              unitWheelSets[0],
              'LH',
              'sensor'
            )}  `}
          />

          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[1],
              'RH'
            )}
            <br />  ${this.getIMEI(unitWheelSets[1], 'RH')}
            `}
            data-for="svgTooltipTop"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[1],
              'RH'
            )}`}
            data-reference={`${this.getReference(unitWheelSets[1], 'RH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[1], 'RH')}`}
            onClick={e =>
              this.onClick(
                e,
                1,
                'RH',
                this.getFunctionalLocation(unitWheelSets[1], 'RH')
              )
            }
            className={`sensorBottomLeft cursor  ${this.getSensor(
              unitWheelSets[1],
              'RH',
              'sensor'
            )}  `}
          />

          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[0],
              'RH'
            )}`}
            data-for="svgTooltipTop"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[0],
              'RH'
            )} 
              <br />  ${this.getIMEI(unitWheelSets[0], 'RH')}
            `}
            data-reference={`${this.getReference(unitWheelSets[0], 'RH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[0], 'RH')}`}
            onClick={e =>
              this.onClick(
                e,
                0,
                'RH',
                this.getFunctionalLocation(unitWheelSets[0], 'RH')
              )
            }
            className={`sensorBottomRight cursor   ${this.getSensor(
              unitWheelSets[0],
              'RH',
              'sensor'
            )}  `}
          />

          {/************* Carriage components ***********/}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49.5mm"
            height="33mm"
            version="1.1"
            key={uuidv1()}
            viewBox="0 0 4950 3300"
            className="imgAdjustUnit"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <g id="Capa_x0020_1" key={uuidv1()}>
              <metadata id="CorelCorpID_0Corel-Layer" />
              {/************* Left Carriage components ***********/}
              <g
                id="CapaLeftGB"
                key={uuidv1()}
                className={` ${this.isOpacity(1)} `}
              >
                <path
                  strokeWidth="30"
                  className={` fil0 ${lastLevel ? '' : ''} `}
                  d="M810.2 2851.88l296.11 0 0 -2403.5 -296.11 0 0 2403.5zm21.8 323.55l252.51 0 0 -276.19 -252.51 0 0 276.19zm0 -276.19l-21.8 -47.36 296.11 0 -21.8 47.36 -252.51 0zm252.51 -2774.61l-252.51 0 0 276.19 252.51 0 0 -276.19zm0 276.19l21.8 47.35 -296.11 0 21.8 -47.35 252.51 0z"
                />
                <path
                  strokeWidth="30"
                  data-tip={`Functional location<br />${this.getFunctionalLocationeGB(
                    unitWheelSets[1],
                    'GB'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[1], 'GB')}
                  `}
                  data-assetkey={`${this.getAssetKeyGB(
                    unitWheelSets[1],
                    'GB'
                  )}`}
                  data-funclocation={`${this.getFunctionalLocationeGB(
                    unitWheelSets[1],
                    'GB'
                  )}`}
                  data-reference={`${this.getReferenceGB(
                    unitWheelSets[1],
                    'GB'
                  )}`}
                  onClick={e => this.onClick(e, 1, 'GB')}
                  data-for="svgTooltipBottom"
                  className={` fil5 ${lastLevel ? '' : ''} ${this.getAlarmGB(
                    wheelsets,
                    unitWheelSets[1],
                    'GearBox'
                  )} ${this.isOpacitymGB(
                    wheelsets,
                    unitWheelSets[1],
                    'GearBox'
                  )}`}
                  d="M1681.3 1886.22l-1035.09 0c-55.38,0 -100.75,45.31 -100.75,100.75l0 368.83c0,55.38 45.3,100.75 100.75,100.75l1035.09 -0.02c55.37,0 100.75,-45.31 100.75,-100.75l0 -368.83c0,-55.42 -45.33,-100.73 -100.75,-100.73z"
                />

                <rect
                  strokeWidth="30"
                  data-tip={`Functional location<br />${this.getFunctionalLocationeGB(
                    unitWheelSets[1],
                    'TM'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[1], 'TM')}
                  `}
                  data-assetkey={`${this.getAssetKeyGB(
                    unitWheelSets[1],
                    'TM'
                  )}`}
                  data-funclocation={`${this.getFunctionalLocationeGB(
                    unitWheelSets[1],
                    'TM'
                  )}`}
                  data-reference={`${this.getReferenceGB(
                    unitWheelSets[1],
                    'TM'
                  )}`}
                  onClick={e => this.onClick(e, 1, 'TM')}
                  data-for="svgTooltipBottom"
                  className={` fil5 ${lastLevel ? '' : ''} ${this.getAlarmGB(
                    wheelsets,
                    unitWheelSets[1],
                    'TractionMotor'
                  )} ${this.isOpacitymGB(
                    wheelsets,
                    unitWheelSets[1],
                    'TractionMotor'
                  )}`}
                  x="1191.59"
                  y="857.52"
                  width="714.23"
                  height="895.44"
                />
                <rect
                  strokeWidth="30"
                  className={` fil1 ${lastLevel ? '' : ''} `}
                  x="1502.51"
                  y="1752.96"
                  width="92.38"
                  height="133.25"
                />
                <rect
                  strokeWidth="30"
                  className={` fil2 ${lastLevel ? '' : ''} `}
                  x="1461.81"
                  y="1752.96"
                  width="173.65"
                  height="31.99"
                />
                <rect
                  strokeWidth="30"
                  className={` fil2 ${lastLevel ? '' : ''} `}
                  x="1461.81"
                  y="825.53"
                  width="173.65"
                  height="31.99"
                />
                <g
                  className={` ${this.isActive(unitWheelSets[1], 'RH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[1],
                    'RH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[1], 'RH')}
                  `}
                  data-for="svgTooltipTop"
                >
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'RH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[1],
                      'RH',
                      'axlebox'
                    )} cursor `}
                    id="LHLeftA"
                    x="574.21"
                    y="2929.15"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'RH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[1],
                      'RH',
                      'wheel'
                    )} cursor `}
                    id="LHLeftW"
                    d="M1745.72 2635.72c22.62,0 30.74,18.61 30.74,40.6 0,14.36 -9.28,35.57 -29.57,35.57l-11.94 0c-2.4,4.42 -2.11,10.51 -2.29,15.23l-18.49 146.89 -1509.7 0.02 -20.67 -146.89c-0.19,-4.74 0.11,-10.83 -2.29,-15.25l-11.93 0c-20.32,0 -29.52,-21.21 -29.52,-35.57 0,-21.99 8.12,-40.6 30.66,-40.6l1575 0z"
                  />
                </g>
                <g
                  className={` ${this.isActive(unitWheelSets[1], 'LH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[1],
                    'LH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[1], 'LH')}
                  `}
                  data-for="svgTooltipBottom"
                >
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'LH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[1],
                      'LH',
                      'axlebox'
                    )} cursor `}
                    id="RHLeftA"
                    x="574.21"
                    y="27.98"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'LH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[1],
                      'LH',
                      'wheel'
                    )} cursor `}
                    id="RHLeftW"
                    d="M181.57 587.59c2.4,-4.42 2.11,-10.51 2.29,-15.23l18.49 -146.89 1509.7 -0.02 20.67 146.89c0.19,4.74 -0.12,10.83 2.29,15.25l11.93 0c20.32,0 29.52,21.21 29.52,35.56 0,21.99 -8.12,40.6 -30.66,40.6l-1575 0c-22.62,0 -30.74,-18.61 -30.74,-40.6 0,-14.35 9.28,-35.56 29.57,-35.56l11.94 0z"
                  />
                </g>
              </g>

              {/************* Right Carriage components ***********/}
              <g
                id="CapaRightGB"
                key={uuidv1()}
                className={` ${this.isOpacity(0)} `}
              >
                <path
                  strokeWidth="30"
                  className={`fil0 ${lastLevel ? '' : ''} `}
                  d="M4139.8 448.12l-296.11 0 0 2403.51 296.11 0 0 -2403.51zm-21.8 -323.55l-252.51 0 0 276.19 252.51 0 0 -276.19zm0 276.19l21.8 47.36 -296.11 0 21.8 -47.36 252.51 0zm-252.51 2774.61l252.51 0 0 -276.19 -252.51 0 0 276.19zm0 -276.19l-21.8 -47.35 296.11 0 -21.8 47.35 -252.51 0z"
                />

                <path
                  strokeWidth="30"
                  data-tip={`Functional location<br />${this.getFunctionalLocationeGB(
                    unitWheelSets[0],
                    'GB'
                  )}`}
                  data-assetkey={`${this.getAssetKeyGB(unitWheelSets[0], 'GB')}
                  <br />  ${this.getIMEI(unitWheelSets[0], 'GB')}
                  `}
                  data-funclocation={`${this.getFunctionalLocationeGB(
                    unitWheelSets[0],
                    'GB'
                  )}`}
                  data-reference={`${this.getReferenceGB(
                    unitWheelSets[0],
                    'GB'
                  )}`}
                  onClick={e => this.onClick(e, 0, 'GB')}
                  data-for="svgTooltipBottom"
                  className={`fil5 ${lastLevel ? '' : ''} ${this.getAlarmGB(
                    wheelsets,
                    unitWheelSets[0],
                    'GearBox'
                  )} ${this.isOpacitymGB(
                    wheelsets,
                    unitWheelSets[0],
                    'GearBox'
                  )}`}
                  d="M3268.71 1413.78l1035.09 0c55.38,0 100.75,-45.3 100.75,-100.75l0 -368.83c0,-55.38 -45.3,-100.75 -100.75,-100.75l-1035.09 0.03c-55.38,0 -100.75,45.3 -100.75,100.74l0 368.84c0,55.42 45.33,100.72 100.75,100.72z"
                />
                <rect
                  strokeWidth="30"
                  data-tip={`Functional location<br />${this.getFunctionalLocationeGB(
                    unitWheelSets[0],
                    'TM'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[0], 'TM')}
                  `}
                  data-assetkey={`${this.getAssetKeyGB(
                    unitWheelSets[0],
                    'TM'
                  )}`}
                  data-funclocation={`${this.getFunctionalLocationeGB(
                    unitWheelSets[0],
                    'TM'
                  )}`}
                  data-reference={`${this.getReferenceGB(
                    unitWheelSets[0],
                    'TM'
                  )}`}
                  onClick={e => this.onClick(e, 0, 'TM')}
                  data-for="svgTooltipBottom"
                  className={`fil5 ${lastLevel ? '' : ''} ${this.getAlarmGB(
                    wheelsets,
                    unitWheelSets[0],
                    'TractionMotor'
                  )} ${this.isOpacitymGB(
                    wheelsets,
                    unitWheelSets[0],
                    'TractionMotor'
                  )}`}
                  x="3044.19"
                  y="1547.04"
                  width="714.23"
                  height="895.44"
                />

                <rect
                  strokeWidth="30"
                  className={`fil1 ${lastLevel ? '' : ''} `}
                  x="3355.12"
                  y="1413.79"
                  width="92.38"
                  height="133.25"
                />
                <rect
                  strokeWidth="30"
                  className={`fil2 ${lastLevel ? '' : ''} `}
                  x="3314.55"
                  y="1515.05"
                  width="173.65"
                  height="31.99"
                />
                <rect
                  strokeWidth="30"
                  className={`fil2 ${lastLevel ? '' : ''} `}
                  x="3314.55"
                  y="2442.48"
                  width="173.65"
                  height="31.99"
                />

                <g
                  className={` ${this.isActive(unitWheelSets[0], 'LH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[0],
                    'LH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[0], 'LH')}
                  `}
                  data-for="svgTooltipBottom"
                >
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'LH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[0],
                      'LH',
                      'axlebox'
                    )} cursor `}
                    id="RHRightA"
                    x="3607.78"
                    y="27.66"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'LH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[0],
                      'LH',
                      'wheel'
                    )} cursor `}
                    id="RHRightW"
                    d="M3204.29 664.28c-22.63,0 -30.75,-18.61 -30.75,-40.6 0,-14.36 9.29,-35.56 29.58,-35.56l11.93 0c2.4,-4.42 2.11,-10.51 2.3,-15.24l18.49 -146.89 1509.69 -0.02 20.68 146.9c0.19,4.74 -0.11,10.83 2.3,15.25l11.91 0c20.33,0 29.53,21.2 29.53,35.56 0,21.99 -8.12,40.6 -30.66,40.6l-1575 0z"
                  />
                </g>
                <g
                  className={`${this.isActive(unitWheelSets[0], 'RH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[0],
                    'RH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[0], 'RH')}
                  `}
                  data-for="svgTooltipTop"
                >
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'RH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[0],
                      'RH',
                      'wheel'
                    )} cursor `}
                    id="LHRightW"
                    d="M4779.21 2636.25c22.62,0 30.74,18.61 30.74,40.6 0,14.36 -9.29,35.56 -29.58,35.56l-11.94 0c-2.39,4.42 -2.1,10.51 -2.28,15.23l-18.49 146.89 -1509.7 0.02 -20.68 -146.89c-0.18,-4.75 0.11,-10.84 -2.3,-15.25l-11.91 0c-20.32,0 -29.53,-21.2 -29.53,-35.56 0,-21.99 8.12,-40.6 30.67,-40.6l1575 0z"
                  />
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'RH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[0],
                      'RH',
                      'axlebox'
                    )} cursor `}
                    id="LHRightA"
                    x="3607.78"
                    y="2928.83"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                </g>
              </g>

              <g id="_3131482930576">
                <path
                  strokeWidth="30"
                  className="fil3"
                  d="M2475 2163.59c-283.97,0 -514.18,-230.22 -514.18,-514.18 0,-283.97 230.21,-514.18 514.18,-514.18 283.96,0 514.18,230.21 514.18,514.18 0,283.96 -230.22,514.18 -514.18,514.18zm394.01 -514.18c0,-217.6 -176.38,-393.98 -393.98,-393.98 -217.59,0 -393.97,176.38 -393.97,393.98 0,217.59 176.38,393.97 393.97,393.97 217.6,0 393.98,-176.38 393.98,-393.97z"
                />
                <path
                  onClick={e => this.onClickBogie(this.props.bogie)}
                  strokeWidth="30"
                  className="fil2"
                  d="M4902.27 2929.31l-1821.02 0c-142.63,-9.45 -219.93,-79.59 -231.89,-210.44l0 -2116.04 0.48 -6.64 0.02 -0.25 0.56 -6.3 0.06 -0.62 0.6 -5.83 0.11 -0.99 0.64 -5.37 0.17 -1.34 0.67 -4.92 0.1 -0.64 0.6 -3.97 0.34 -2.22 0.55 -3.31 0.58 -3.34 0.57 -3.04 0.51 -2.67 0.8 -3.93 0.39 -1.83 0.84 -3.8 0.59 -2.53 0.73 -3.02 0.83 -3.27 0.6 -2.29 0.9 -3.29 0.82 -2.87 0.61 -2.05 1.04 -3.42 0.16 -0.54 1.37 -4.24 0.11 -0.31 1.1 -3.22 0.89 -2.53 0.07 -0.21 1.74 -4.68 0.17 -0.43 1.94 -4.88 0.05 -0.13 2.09 -4.92 1.53 -3.4 0.64 -1.43 0.2 -0.43 2.07 -4.3 0.34 -0.69 2.01 -3.94 0.09 -0.16 1.71 -3.19 0.88 -1.62 1.67 -2.93 0.85 -1.47 1.76 -2.92 0.97 -1.58 1.8 -2.83 0.95 -1.45 2.13 -3.16 0.5 -0.73 2.35 -3.3 0.65 -0.89 2.5 -3.32 0.41 -0.53 2.4 -3.04 1.08 -1.31 2.21 -2.65 0.89 -1.03 2.34 -2.66 1.15 -1.25 2.25 -2.42 0.83 -0.85c2.05,-2.13 4.15,-4.2 6.29,-6.22l3.47 -3.19 0.12 -0.1 3.69 -3.19 3.28 -2.71 0.49 -0.4 0.32 -0.26 3.55 -2.74 3.6 -2.65 0.44 -0.32c2.59,-1.85 5.23,-3.64 7.93,-5.37l0.23 -0.15 3.79 -2.35 0.54 -0.33 3.76 -2.21 0.58 -0.33 3.92 -2.17 0.52 -0.28 4.02 -2.08 0.39 -0.2c2.85,-1.43 5.75,-2.82 8.7,-4.14l0.89 -0.39c2.86,-1.26 5.77,-2.48 8.73,-3.64l1.29 -0.49c17.6,-6.77 36.93,-11.69 57.99,-14.76l0.25 -0.04c3.77,-0.54 7.59,-1.03 11.47,-1.46l0.69 -0.07 5.75 -0.58 1842.66 0 0 -185.52 -4854.52 0 0 185.52 2052.89 0 0 29.87 -0.18 -29.62 -232.31 0 6.69 0.49 0.34 0.02 6.24 0.55 0.68 0.07 5.82 0.6 1 0.11 2.2 0.27 3.94 0.47 0.57 0.07 4.98 0.68 0.55 0.08 3.48 0.53 3.04 0.47 3.82 0.64 2.09 0.36 3.56 0.66 2.94 0.57 3.47 0.71 2.18 0.46 3.56 0.79 2.72 0.64 3.21 0.78 2.55 0.64 2.9 0.76 3.23 0.89 2.62 0.74 2.92 0.87 2.38 0.73 3.94 1.26 1.52 0.5 3.3 1.14 2.29 0.8 2.99 1.1 1.9 0.71 0.85 0.33 1.71 0.68 3.3 1.33 0.27 0.11 4.7 2 4.8 2.17 0.05 0.03 4.74 2.28 0.2 0.1 4.45 2.28 2.7 1.45 2.37 1.3 0.14 0.08 3.8 2.19 0.26 0.16 2.95 1.78 1.44 0.88 2.93 1.88 1.46 0.96 3.05 2.07 1.02 0.71 2.98 2.13 1.15 0.84 3.13 2.37 0.92 0.71 2.47 1.97 1.73 1.42 2.65 2.24 0.68 0.59 2.99 2.66 0.88 0.81 2.76 2.59 0.75 0.72 2.91 2.89 0.51 0.52 2.71 2.83 1.07 1.17 2.44 2.7 0.52 0.61 2.53 2.94 1.24 1.51 2.07 2.54 0.24 0.32c3.97,5.04 7.7,10.32 11.18,15.82l0.03 0.06c1.54,2.43 3.01,4.91 4.45,7.44l0.85 1.49 1.66 3.05 0.7 1.3c1.48,2.8 2.89,5.65 4.26,8.56l0.28 0.59 1.74 3.87 0.49 1.12 1.32 3.09 0.84 2.05 1.43 3.61 0.32 0.85 1.58 4.28 0.24 0.69 1.57 4.57 0.11 0.32 1.51 4.75 0.24 0.77 1.25 4.27 0.43 1.52 1.08 3.97 0.25 1.01 1.16 4.62 0.19 0.81 1.01 4.43 0.49 2.32 0.73 3.54 0.21 1.11c0.67,3.47 1.29,6.98 1.85,10.55l0.87 5.89 0.02 0.1 0.75 5.88 0.59 5.25 0.09 0.81 0.08 0.75 0.5 5.41 0 2345.84 -0.01 0 0 -232.28c-9.34,142.83 -79.43,220.25 -210.26,232.28l-1842.62 0 0 185.52 4854.52 0 0 -185.52z"
                />
              </g>
            </g>
          </svg>
          <ReactTooltip place="top" multiline={true} id="svgTooltipTop" />
          <ReactTooltip place="bottom" multiline={true} id="svgTooltipBottom" />
        </div>
      );
    } else if (!isMotor) {
      return (
        <div key={uuidv1()}>
          {/************* Sensors positions ***********/}
          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[1],
              'LH'
            )}
            <br />  ${this.getIMEI(unitWheelSets[1], 'LH')}
            `}
            data-for="svgTooltipBottom"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[1],
              'LH'
            )}`}
            data-reference={`${this.getReference(unitWheelSets[1], 'LH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[1], 'LH')}`}
            onClick={e => this.onClick(e, 1, 'LH')}
            className={`sensorTopLeft  cursor ${this.getSensor(
              unitWheelSets[1],
              'LH',
              'sensor'
            )} `}
          />
          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[0],
              'LH'
            )}
            <br />  ${this.getIMEI(unitWheelSets[0], 'LH')}
            `}
            data-for="svgTooltipBottom"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[0],
              'LH'
            )}`}
            data-reference={`${this.getReference(unitWheelSets[0], 'LH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[0], 'LH')}`}
            onClick={e => this.onClick(e, 0, 'LH')}
            className={`sensorTopRight  cursor ${this.getSensor(
              unitWheelSets[0],
              'LH',
              'sensor'
            )}  `}
          />
          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[1],
              'RH'
            )}
            <br />  ${this.getIMEI(unitWheelSets[1], 'RH')}
            `}
            data-for="svgTooltipTop"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[1],
              'RH'
            )}`}
            data-reference={`${this.getReference(unitWheelSets[1], 'RH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[1], 'RH')}`}
            onClick={e => this.onClick(e, 1, 'RH')}
            className={`sensorBottomLeft  cursor ${this.getSensor(
              unitWheelSets[1],
              'RH',
              'sensor'
            )}  `}
          />
          <img
            src={sensorRed}
            data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
              unitWheelSets[0],
              'RH'
            )}
            <br />  ${this.getIMEI(unitWheelSets[0], 'RH')}
            `}
            data-for="svgTooltipTop"
            data-funclocation={`${this.getFunctionalLocation(
              unitWheelSets[0],
              'RH'
            )}`}
            data-reference={`${this.getReference(unitWheelSets[0], 'RH')}`}
            data-assetkey={`${this.getAssetKey(unitWheelSets[0], 'RH')}`}
            onClick={e => this.onClick(e, 0, 'RH')}
            className={`sensorBottomRight cursor  ${this.getSensor(
              unitWheelSets[0],
              'RH',
              'sensor'
            )}  `}
          />

          {/************* Carriage components ***********/}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49.5mm"
            height="33mm"
            version="1.1"
            key={uuidv1()}
            viewBox="0 0 4950 3300"
            className="imgAdjustUnit"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <g id="Capa_x0020_1" key={uuidv1()}>
              <metadata id="CorelCorpID_0Corel-Layer" />
              {/************* Left Carriage components ***********/}
              <g
                id="CapaLeftAX"
                key={uuidv1()}
                className={` ${this.isOpacity(1)} `}
              >
                <path
                  strokeWidth="30"
                  className={`fil0   ${lastLevel ? '' : ''} `}
                  d="M810.2 2851.88l296.11 0 0 -2403.5 -296.11 0 0 2403.5zm21.8 323.55l252.51 0 0 -276.19 -252.51 0 0 276.19zm0 -276.19l-21.8 -47.36 296.11 0 -21.8 47.36 -252.51 0zm252.51 -2774.61l-252.51 0 0 276.19 252.51 0 0 -276.19zm0 276.19l21.8 47.35 -296.11 0 21.8 -47.35 252.51 0z"
                />

                <g
                  onClick={e => this.onClick(e, 1, 'RH')}
                  className={` ${this.isActive(unitWheelSets[1], 'RH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[1],
                    'RH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[1], 'RH')}
                  `}
                  data-for="svgTooltipTop"
                >
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'RH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[1],
                      'RH',
                      'axlebox'
                    )} cursor `}
                    id="LHLeftA"
                    x="574.21"
                    y="2929.15"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'RH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[1],
                      'RH',
                      'wheel'
                    )} cursor `}
                    id="RHLeftW"
                    d="M1745.72 2635.72c22.62,0 30.74,18.61 30.74,40.6 0,14.36 -9.28,35.57 -29.57,35.57l-11.94 0c-2.4,4.42 -2.11,10.51 -2.29,15.23l-18.49 146.89 -1509.7 0.02 -20.67 -146.89c-0.19,-4.74 0.11,-10.83 -2.29,-15.25l-11.93 0c-20.32,0 -29.52,-21.21 -29.52,-35.57 0,-21.99 8.12,-40.6 30.66,-40.6l1575 0z"
                  />
                </g>
                <g
                  onClick={e => this.onClick(e, 1, 'LH')}
                  className={` ${this.isActive(unitWheelSets[1], 'LH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[1],
                    'LH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[1], 'LH')}
                  `}
                  data-for="svgTooltipBottom"
                >
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'LH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[1],
                      'LH',
                      'wheel'
                    )} cursor `}
                    id="LHLeftW"
                    d="M181.57 587.59l0.11 -0.21 0.09 -0.17 0.02 -0.04 0.1 -0.21 0.06 -0.13 0.04 -0.09 0.09 -0.22 0.04 -0.07 0.06 -0.14 0.09 -0.23 0.01 -0.03 0.07 -0.19 0.07 -0.2 0.01 -0.03 0.08 -0.22 0.05 -0.16 0.03 -0.07 0.07 -0.23 0.03 -0.11 0.04 -0.12 0.06 -0.24 0.02 -0.05 0.04 -0.18 0.07 -0.24 0.05 -0.24 0.05 -0.19 0.01 -0.05 0.05 -0.24 0.03 -0.13 0.02 -0.11 0.05 -0.24 0.01 -0.09 0.03 -0.16 0.04 -0.24 0.01 -0.03 0.03 -0.22 0.04 -0.22 0 -0.02 0.04 -0.25 0.02 -0.17 0.01 -0.08 0.03 -0.25 0.01 -0.11 0.02 -0.13 0.03 -0.25 0 -0.06 0.02 -0.19 0.03 -0.25 0.02 -0.25 0.02 -0.2 0 -0.05 0.02 -0.25 0.01 -0.14 0.01 -0.11 0.02 -0.25 0 -0.09 0.01 -0.16 0.02 -0.25 0 -0.03 0.01 -0.22 0.01 -0.22 0 -0.03 0.01 -0.25 0.01 -0.16 0 -0.09 0.01 -0.25 0.01 -0.1 0 -0.14 0.01 -0.25 0 -0.05 0.01 -0.2 0 -0.24 0.01 -0.24 0 -0.19 0.01 -0.06 0 -0.24 0 -0.13 0.01 -0.11 0 -0.24 0 -0.08 0.01 -0.16 0 -0.24 0 -0.02 0.01 -0.21 0 -0.21 0 -0.03 0.01 -0.23 0 -0.15 0 -0.08 0.01 -0.23 0 -0.1 0.01 -0.13 0 -0.22 0.01 -0.05 0 -0.18 0.01 -0.22 18.49 -146.89 1509.7 -0.02 20.67 146.89 0.01 0.22 0 0.18 0.01 0.05 0 0.23 0.01 0.12 0 0.1 0.01 0.23 0 0.08 0 0.16 0.01 0.23 0 0.02 0 0.21 0.01 0.21 0 0.03 0 0.24 0.01 0.16 0 0.08 0.01 0.24 0 0.1 0 0.14 0.01 0.24 0 0.05 0 0.2 0.01 0.24 0.01 0.25 0 0.18 0 0.06 0.01 0.25 0.01 0.13 0 0.12 0.01 0.25 0 0.07 0.01 0.17 0.01 0.25 0 0.02 0.01 0.23 0.02 0.22 0 0.03 0.01 0.25 0.01 0.16 0.01 0.09 0.01 0.25 0.01 0.11 0.01 0.14 0.02 0.25 0.01 0.05 0.01 0.2 0.05 0.5 0.02 0.19 0 0.06 0.03 0.25 0.02 0.13 0.01 0.12 0.03 0.25 0.01 0.07 0.02 0.18 0.04 0.25 0.01 0.01 0.03 0.23 0.04 0.21 0 0.04 0.04 0.24 0.03 0.15 0.01 0.1 0.05 0.24 0.02 0.09 0.03 0.15 0.16 0.7 0 0.02 0.06 0.24 0.05 0.16 0.02 0.07 0.06 0.24 0.04 0.11 0.03 0.12 0.23 0.68 0.01 0.01 0.07 0.22 0.07 0.18 0.01 0.04 0.09 0.23 0.06 0.12 0.03 0.09 0.1 0.22 0.04 0.08 0.06 0.14 0.1 0.21 0.02 0.02 0.09 0.19 0.1 0.19 0.01 0.02 11.93 0c20.32,0 29.52,21.21 29.52,35.56 0,21.99 -8.12,40.6 -30.66,40.6l-1575 0c-22.62,0 -30.74,-18.61 -30.74,-40.6 0,-14.35 9.28,-35.56 29.57,-35.56l11.94 0z"
                  />
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[1],
                      'LH'
                    )}`}
                    onClick={e => this.onClick(e, 1, 'LH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[1],
                      'LH',
                      'axlebox'
                    )} cursor `}
                    id="RHLeftA"
                    x="574.21"
                    y="27.98"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                </g>
              </g>
              {/************* Right Carriage components ***********/}
              <g
                id="CapaRightAX"
                key={uuidv1()}
                className={` ${this.isOpacity(0)} `}
              >
                <path
                  strokeWidth="30"
                  className={`fil0   ${lastLevel ? '' : ''} `}
                  d="M4139.8 448.12l-296.11 0 0 2403.51 296.11 0 0 -2403.51zm-21.8 -323.55l-252.51 0 0 276.19 252.51 0 0 -276.19zm0 276.19l21.8 47.36 -296.11 0 21.8 -47.36 252.51 0zm-252.51 2774.61l252.51 0 0 -276.19 -252.51 0 0 276.19zm0 -276.19l-21.8 -47.35 296.11 0 -21.8 47.35 -252.51 0z"
                />

                <g
                  onClick={e => this.onClick(e, 0, 'LH')}
                  className={` ${this.isActive(unitWheelSets[0], 'LH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[0],
                    'LH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[0], 'LH')}
                  `}
                  data-for="svgTooltipBottom"
                >
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'LH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[0],
                      'LH',
                      'axlebox'
                    )} cursor `}
                    id="RHRightA"
                    x="3607.78"
                    y="27.66"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'LH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'LH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[0],
                      'LH',
                      'wheel'
                    )} cursor `}
                    id="RHRightW"
                    d="M3204.29 664.28c-22.63,0 -30.75,-18.61 -30.75,-40.6 0,-14.36 9.29,-35.56 29.58,-35.56l11.93 0c2.4,-4.42 2.11,-10.51 2.3,-15.24l18.49 -146.89 1509.69 -0.02 20.68 146.9c0.19,4.74 -0.11,10.83 2.3,15.25l11.91 0c20.33,0 29.53,21.2 29.53,35.56 0,21.99 -8.12,40.6 -30.66,40.6l-1575 0z"
                  />
                </g>
                <g
                  onClick={e => this.onClick(e, 0, 'RH')}
                  className={` ${this.isActive(unitWheelSets[0], 'RH')} `}
                  data-tip={`Functional location<br />AxleBox ID: ${this.getFunctionalLocation(
                    unitWheelSets[0],
                    'RH'
                  )}
                  <br />  ${this.getIMEI(unitWheelSets[0], 'RH')}
                  `}
                  data-for="svgTooltipTop"
                >
                  <path
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'RH')}
                    className={`fil1 wheel ${this.getAlarm(
                      unitWheelSets[0],
                      'RH',
                      'wheel'
                    )} cursor `}
                    id="LHRightW"
                    d="M4779.21 2636.25c22.62,0 30.74,18.61 30.74,40.6 0,14.36 -9.29,35.56 -29.58,35.56l-11.94 0c-2.39,4.42 -2.1,10.51 -2.28,15.23l-18.49 146.89 -1509.7 0.02 -20.68 -146.89c-0.18,-4.75 0.11,-10.84 -2.3,-15.25l-11.91 0c-20.32,0 -29.53,-21.2 -29.53,-35.56 0,-21.99 8.12,-40.6 30.67,-40.6l1575 0z"
                  />
                  <rect
                    strokeWidth="30"
                    data-funclocation={`${this.getFunctionalLocation(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-reference={`${this.getReference(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    data-assetkey={`${this.getAssetKey(
                      unitWheelSets[0],
                      'RH'
                    )}`}
                    onClick={e => this.onClick(e, 0, 'RH')}
                    className={`fil1 bearing ${this.getAlarm(
                      unitWheelSets[0],
                      'RH',
                      'axlebox'
                    )} cursor `}
                    id="LHRightA"
                    x="3607.78"
                    y="2928.83"
                    width="768.01"
                    height="343.19"
                    rx="44.62"
                    ry="26.42"
                  />
                </g>
              </g>
              <g id="_3131482660912">
                <path
                  strokeWidth="30"
                  className="fil2"
                  onClick={e => this.onClickBogie(this.props.bogie)}
                  d="M2100.64 370.69l0 29.87 -0.18 -29.62 -232.31 0 6.69 0.49 0.34 0.02 6.24 0.55 0.68 0.07 5.82 0.6 1 0.11 2.2 0.27 3.94 0.47 0.57 0.07 4.98 0.68 0.55 0.08 3.48 0.53 3.04 0.47 3.82 0.64 2.09 0.36 3.56 0.66 2.94 0.57 3.47 0.71 2.18 0.46 3.56 0.79 2.72 0.64 3.21 0.78 2.55 0.64 2.9 0.76 3.23 0.89 2.62 0.74 2.92 0.87 2.38 0.73 3.94 1.26 1.52 0.5 3.3 1.14 2.29 0.8 2.99 1.1 1.9 0.71 0.85 0.33 1.71 0.68 3.3 1.33 0.27 0.11 4.7 2 4.8 2.17 0.05 0.03 4.74 2.28 0.2 0.1 4.45 2.28 2.7 1.45 2.37 1.3 0.14 0.08 3.8 2.19 0.26 0.16 2.95 1.78 1.44 0.88 2.93 1.88 1.46 0.96 3.05 2.07 1.02 0.71 2.98 2.13 1.15 0.84 3.13 2.37 0.92 0.71 2.47 1.97 1.73 1.42 2.65 2.24 0.68 0.59 2.99 2.66 0.88 0.81 2.68 2.51 1.09 1.07 2.45 2.42 1.06 1.09 2.36 2.46 1.07 1.17 2.44 2.7 0.52 0.61 2.53 2.94 1.24 1.51 2.07 2.54 0.24 0.32c3.97,5.04 7.71,10.32 11.18,15.82l0.03 0.06c1.54,2.43 3.01,4.91 4.45,7.44l0.85 1.49 1.66 3.05 0.7 1.3c1.48,2.8 2.89,5.65 4.26,8.56l0.28 0.59 1.74 3.87 0.49 1.12 1.32 3.09 0.84 2.05 1.43 3.61 0.32 0.85 1.58 4.28 0.24 0.69 1.57 4.57 0.11 0.32 1.51 4.75 0.24 0.77 1.25 4.27 0.43 1.52 1.08 3.97 0.25 1.01 1.16 4.62 0.19 0.81 1.01 4.43 0.49 2.32 0.73 3.54 0.21 1.11c0.67,3.47 1.29,6.98 1.85,10.55l0.87 5.89 0.02 0.1 0.75 5.88 0.59 5.25 0.09 0.81 0.08 0.75 0.5 5.41 0 2345.84 -0.01 0 0 -232.28c-9.34,142.83 -79.43,220.25 -210.26,232.28l-1842.62 0 0 185.52 4854.52 0 0 -185.52 -1821.02 0c-142.63,-9.45 -219.93,-79.59 -231.89,-210.44l0 -2116.04 0.48 -6.64 0.02 -0.25 0.56 -6.3 0.06 -0.62 0.6 -5.83 0.11 -0.99 0.64 -5.37 0.17 -1.34 0.67 -4.92 0.1 -0.64 0.6 -3.97 0.34 -2.22 0.55 -3.31 0.58 -3.34 0.57 -3.04 0.51 -2.67 0.8 -3.93 0.39 -1.83 0.84 -3.8 0.59 -2.53 0.73 -3.02 0.83 -3.27 0.6 -2.29 0.9 -3.29 0.82 -2.87 0.61 -2.05 1.04 -3.42 0.16 -0.54 1.37 -4.24 0.11 -0.31 1.1 -3.22 0.89 -2.53 0.07 -0.21 1.74 -4.68 0.17 -0.43 1.94 -4.88 0.05 -0.13 2.09 -4.92 1.53 -3.4 0.64 -1.43 0.2 -0.43 2.07 -4.3 0.34 -0.69 2.01 -3.94 0.09 -0.16 1.71 -3.19 0.88 -1.62 1.67 -2.93 0.85 -1.47 1.76 -2.92 0.97 -1.58 1.8 -2.83 0.95 -1.45 2.13 -3.15 0.5 -0.73 2.35 -3.31 0.65 -0.89 2.5 -3.32 0.41 -0.53 2.4 -3.04 1.08 -1.31 2.21 -2.65 0.89 -1.03 2.34 -2.66 1.15 -1.25 2.22 -2.39 1.24 -1.27 2.31 -2.35 0.66 -0.64 2.94 -2.84 3.47 -3.19 0.12 -0.1 3.69 -3.19 3.28 -2.71 0.49 -0.4 0.32 -0.26 3.55 -2.74 3.6 -2.65 0.44 -0.32c2.59,-1.85 5.23,-3.64 7.93,-5.37l0.23 -0.15 3.79 -2.35 0.54 -0.33 3.76 -2.21 0.58 -0.33 3.92 -2.17 0.52 -0.28 4.02 -2.08 0.39 -0.2c2.85,-1.43 5.75,-2.82 8.7,-4.14l0.89 -0.39c2.86,-1.26 5.77,-2.48 8.73,-3.64l1.29 -0.49c17.59,-6.77 36.93,-11.69 57.99,-14.76l0.25 -0.04c3.77,-0.54 7.59,-1.03 11.47,-1.46l0.69 -0.07 5.75 -0.58 1842.66 0 0 -185.52 -4854.52 0 0 185.52 2052.89 0z"
                />
                <path
                  strokeWidth="30"
                  className="fil3"
                  d="M2475 2163.59c-283.97,0 -514.18,-230.22 -514.18,-514.18 0,-283.97 230.21,-514.18 514.18,-514.18 283.96,0 514.18,230.21 514.18,514.18 0,283.96 -230.22,514.18 -514.18,514.18zm394.01 -514.18c0,-217.6 -176.38,-393.98 -393.98,-393.98 -217.59,0 -393.97,176.38 -393.97,393.98 0,217.59 176.38,393.97 393.97,393.97 217.6,0 393.98,-176.38 393.98,-393.97z"
                />
              </g>
            </g>
          </svg>
          <ReactTooltip place="top" multiline={true} id="svgTooltipTop" />
          <ReactTooltip place="bottom" multiline={true} id="svgTooltipBottom" />
        </div>
      );
    }
  }
}

export default TrailerBogie;
